import { useState } from "preact/hooks";
import { newPairCode } from "../account/accountApi";
import { agentPrompt } from "../account/agentPrompt";
import { ApiError } from "../net/api";
import { toast } from "../state/stores";
import { describeError } from "./errors";

export const PROMPT_AGENT_NAME = "我的 agent";

/** Pause-menu button: a fresh pair code, the prompt on the clipboard, or a text box to copy by hand (spec 2e §4.1). */
export function AgentPromptButton() {
  const [busy, setBusy] = useState(false);
  const [manual, setManual] = useState<string | null>(null);
  async function copy() {
    if (busy) return;
    setBusy(true);
    setManual(null);
    let code: string | null = null, failure: string | null = null;
    try {
      code = (await newPairCode(PROMPT_AGENT_NAME)).code;
    } catch (e) {
      failure = e instanceof ApiError ? describeError(e.code, e.message) : "無法連線到伺服器";
    }
    const text = agentPrompt(location.origin, code);
    try {
      if (!navigator.clipboard) throw new Error("clipboard unavailable");
      await navigator.clipboard.writeText(text);
      toast(failure ? `已複製提示詞（只含瀏覽器授權）：${failure}` : "已複製提示詞。配對碼 10 分鐘內有效、只能用一次", 6000);
    } catch {
      setManual(text); // the code lives only here and on screen, never in storage
    } finally {
      setBusy(false);
    }
  }
  return (
    <>
      <button class="secondary" disabled={busy} onClick={() => void copy()}>複製 agent 提示詞</button>
      {manual && (
        <div class="prompt-manual">
          <p class="hint">請按 ⌘C／Ctrl+C 複製</p>
          <textarea readOnly rows={10} value={manual} ref={(el) => el?.select()} />
        </div>
      )}
    </>
  );
}
